export const ROOT_STATE_KEY = "3pq-configuration-root";
//# sourceMappingURL=constants.js.map